import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import App from './App';

// Point d'entrée : on accroche React à la div#root du public/index.html.
// StrictMode = mode dev strict, détecte les effets de bord suspects en
// rendant certains composants 2× (pas en prod). Sans impact visible.
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);